import SelectWithInput from "./SelectWithInput";
import {Consts} from "../../pages/consts";
import {phenotypeOptions} from "../../../resources/json/jsons";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {getInputFocusStyle} from "../../pages/utils";

const GenoAndPhenoSelection = ({ setPhenotype, setAllele1, setAllele2}) => {
  const { t } = useTranslation();
  const [selectedPhenoValue, setSelectedPhenoValue] = useState("");
  const [customPhenoValue, setCustomPhenoValue] = useState("");
  const [isCustomPheno, setIsCustomPheno] = useState(false);
  const [isTextFieldFocused, setIsTextFieldFocused] = useState(false);

  const handleSelectChangePheno = (e) => {
    const value = e.target.value;
    setSelectedPhenoValue(value);
    setIsCustomPheno(value === Consts.OTHER);

    if (value !== Consts.OTHER) {
      setCustomPhenoValue("");
    }

    setPhenotype (e.target.value);
  };

  const handleInputPhenoChange = (e) => {
    setCustomPhenoValue(e.target.value);
    setPhenotype (e.target.value);
  };

  return (
    <div style={{ textAlign: 'left' }}>
      <div className="w3-row w3-margin-bottom">
        <label className="w3-col s12">{t("select_phenotype")}</label>
        <select
          value={selectedPhenoValue}
          onChange={handleSelectChangePheno}
          className="w3-col select_box_style w3-margin-right meds-sort-select drugs-sort-select-local"
        >
          <option value="" disabled>{t("select_phenotype")}</option>
          {phenotypeOptions?.map((option, index) => (
            <option key={index} value={option}>{t(option)}</option>
          ))}
        </select>
        {isCustomPheno && (
          <input
            type={Consts.TEXT}
            placeholder={t("or_enter_manually")}
            value={customPhenoValue}
            onChange={handleInputPhenoChange}
            onFocus={() => setIsTextFieldFocused(true)}
            onBlur={() => setIsTextFieldFocused(false)}
            className="w3-col s9 select_box_style w3-margin-top"
            style={getInputFocusStyle(isTextFieldFocused)}
          />
        )}
      </div>
      <label className="w3-margin-top">{t("select_genotype")}</label>
      <SelectWithInput
        setAllele1 = {setAllele1}
        setAllele2 = {setAllele2}
      />
    </div>
  );
}

export default GenoAndPhenoSelection;